export default "__VITE_ASSET__BdrcHCSN__"